import { IApplicationState } from '../../../../../../types/types';

export const getCommentValue = (state: IApplicationState) => state.comments.value;
